import styled from 'styled-components'
import { media } from '~/components/GlobalStyle'

type IFlex = {
  alignitems?: string
  justifycontent?: string
  direction?: string
  gap?: string
  padding?: string
  bordertop?: boolean
  mobiledirection?: string
}

export const Flex = styled.div<IFlex>`
  display: flex;
  align-items: ${(props) => (props.alignitems ? props.alignitems : 'initial')};
  justify-content: ${(props) =>
    props.justifycontent ? props.justifycontent : 'initial'};
  flex-direction: ${(props) =>
    props.mobiledirection
      ? props.mobiledirection
      : props.direction
        ? props.direction
        : 'initial'};
  gap: ${(props) => (props.gap ? props.gap : '0')};
  padding: ${(props) => (props.padding ? props.padding : '0')};
  border-top: 1px solid
    ${(props) => (props.bordertop ? props.theme.border.color : 'transparent')};

  ${media.medium} {
    flex-direction: ${(props) =>
      props.direction ? props.direction : 'initial'};
  }
`
